import React from 'react';
import {
    Tag,
} from '@shopify/polaris';

class GenieTag extends React.Component {

    constructor(props) {
        super(props)

        this.tagElement = React.createRef();
    }

    render() {
        const props = this.props;
        let tagName = props.children;
        let className = "genieTagContainer";

        if (props.state === "added") {
            className += " add";
        }

        if (props.highlighted === true) {
            className += " highlighted";
        }

        if (props.state === "removed") {
            className += " remove";
        }

        if (props.selected) {
            className += " selected";
        }

        const onRemoveHandler = props.onRemove != null ? () => props.onRemove(tagName) : null;
        if (props.onClick == null) {
            return <div className={className} ref={this.setTextInputRef}><Tag onRemove={onRemoveHandler}>{tagName}</Tag></div>
        }
        else {
            return <div className={className + " clickable"} onClick={() => props.onClick(tagName)} ref={this.setTextInputRef}><Tag onRemove={onRemoveHandler}>{tagName}</Tag></div>
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.backgroundColor !== this.props.backgroundColor) {
            this.updateBackgroundColor();
        }
    }

    setTextInputRef = (element) => {
        this.tagElement = element;
    };

    updateBackgroundColor = () => {
        if (this.tagElement == null) {
            return;
        }

        // if (this.tagElement.children.length > 0 && this.props.backgroundColor != null) {
        if (this.tagElement.children.length > 0) {
            this.tagElement.children[0].style.backgroundColor = this.props.backgroundColor;
        }
    }

    componentDidMount() {
        this.updateBackgroundColor();
    }
}

GenieTag.defaultProps = {
    children: "default",
    onClick: null,
    onRemove: null,
    selected: false,
    highlighted: false,
    state: "default" // default, added, removed, highlighted
}

function ToGenieTag(tags) {

    return tags.map(item => {

        let state = "default";

        if (item.change === "Added") {
            state = "added";
        }
        if (item.change === "Removed") {
            state = "removed";
        }

        return <GenieTag selectable={false} state={state}>{item.tagName}</GenieTag>
    });
}

export { GenieTag, ToGenieTag };